<div class="maps-detail-page">
    <!-- Header Section -->
    <div class="page-header">
        <div class="header-content">
            <button class="back-btn" (click)="goBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title-section">
                <div class="title-icon">
                    <mat-icon>map</mat-icon>
                </div>
                <div class="title-text">
                    <h1>Live Tracking</h1>
                    <p class="subtitle">Order #{{ selectedOrder.reference || selectedOrder.id }}</p>
                </div>
            </div>
            <div class="header-actions">
                <button class="action-btn" (click)="centerOnTruck()">
                    <mat-icon>my_location</mat-icon>
                </button>
                <button class="action-btn" (click)="fitAllMarkers()">
                    <mat-icon>fit_screen</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
        <!-- Map Container -->
        <div class="map-container">
            <google-map #map [options]="mapOptions" height="100%" width="100%" [center]="center" (mapClick)="onMapClick($event)">
                <!-- Start Marker -->
                <map-marker [position]="from" title="Start Location" [options]="{ icon: warehouseIcon, zIndex: 999 }"></map-marker>

                <!-- Car Marker with Custom Icon -->
                <map-marker [position]="currentTruckLocation" title="Car Location" [options]="{ icon: carIcon, zIndex: 999 }"></map-marker>

                <!-- End Marker -->
                <map-marker [position]="to" title="Destination" [options]="{ icon: destinationIcon, zIndex: 999 }"></map-marker>
            </google-map>

            <!-- Map Legend -->
            <div class="map-legend">
                <div class="legend-item">
                    <div class="legend-marker origin"></div>
                    <span>Origin</span>
                </div>
                <div class="legend-item">
                    <div class="legend-marker truck"></div>
                    <span>Current Location</span>
                </div>
                <div class="legend-item">
                    <div class="legend-marker destination"></div>
                    <span>Destination</span>
                </div>
            </div>
        </div>

        <!-- Info Panel -->
        <div class="info-panel">
            <div class="panel-header">
                <h3>
                    <mat-icon>route</mat-icon>
                    Route Information
                </h3>
            </div>

            <div class="route-info">
                <!-- Origin -->
                <div class="route-point">
                    <div class="point-marker origin">
                        <mat-icon>warehouse</mat-icon>
                    </div>
                    <div class="point-details">
                        <span class="point-label">Origin</span>
                        <span class="point-address">{{ selectedOrder.from?.location || 'Loading...' }}</span>
                    </div>
                </div>

                <div class="route-connector">
                    <div class="connector-line completed"></div>
                    <div class="connector-info">
                        <mat-icon>local_shipping</mat-icon>
                        <span>In Transit</span>
                    </div>
                </div>

                <!-- Current Location -->
                <div class="route-point current">
                    <div class="point-marker truck">
                        <mat-icon>local_shipping</mat-icon>
                    </div>
                    <div class="point-details">
                        <span class="point-label">Current Location</span>
                        <span class="point-address">On the way to destination</span>
                    </div>
                </div>

                <div class="route-connector">
                    <div class="connector-line pending"></div>
                    <div class="connector-info pending">
                        <mat-icon>schedule</mat-icon>
                        <span>Remaining</span>
                    </div>
                </div>

                <!-- Destination -->
                <div class="route-point">
                    <div class="point-marker destination">
                        <mat-icon>flag</mat-icon>
                    </div>
                    <div class="point-details">
                        <span class="point-label">Destination</span>
                        <span class="point-address">{{ selectedOrder.to?.location || 'Loading...' }}</span>
                    </div>
                </div>
            </div>

            <!-- Status Card -->
            <div class="status-card">
                <div class="status-icon">
                    <mat-icon>{{ selectedOrder.status === 'Delivered' ? 'check_circle' : 'local_shipping' }}</mat-icon>
                </div>
                <div class="status-info">
                    <span class="status-label">Status</span>
                    <span class="status-value">{{ selectedOrder.status || 'In Transit' }}</span>
                </div>
                <div class="progress-ring">
                    <span class="progress-value">{{ selectedOrder.progress || 0 }}%</span>
                </div>
            </div>
        </div>
    </div>
</div>
